import { permaStickers, yardSigns, banners } from "../../images";

let decalsAndSignageList = [
  {
    img: permaStickers,
    title: "PERMA-STICKERS",
  },
  {
    img: yardSigns,
    title: "YARD SIGNS",
  },
  {
    img: banners,
    title: "BANNERS",
  },
];
export default decalsAndSignageList;
